import { CoreModule, provideAbpCore, withOptions } from '@abp/ng.core';
import { provideAbpOAuth } from '@abp/ng.oauth';
import { provideSettingManagementConfig } from '@abp/ng.setting-management/config';
import { provideFeatureManagementConfig } from '@abp/ng.feature-management';
import { ThemeSharedModule, provideAbpThemeShared, provideLogo, withEnvironmentOptions, withValidationBluePrint,withHttpErrorConfig} from '@abp/ng.theme.shared';
import { IdentityConfigModule, provideIdentityConfig } from '@volo/abp.ng.identity/config';
import { provideCommercialUiConfig } from '@volo/abp.commercial.ng.ui/config';
import { AccountAdminConfigModule, provideAccountAdminConfig } from '@volo/abp.ng.account/admin/config';
import { provideAccountPublicConfig } from '@volo/abp.ng.account/public/config';
import { AuditLoggingConfigModule, provideAuditLoggingConfig } from '@volo/abp.ng.audit-logging/config';
import { provideLanguageManagementConfig } from '@volo/abp.ng.language-management/config';
import { registerLocale } from '@volo/abp.ng.language-management/locale';
import { provideSaasConfig } from '@volo/abp.ng.saas/config';
import { provideTextTemplateManagementConfig } from '@volo/abp.ng.text-template-management/config';
import { provideOpeniddictproConfig } from '@volo/abp.ng.openiddictpro/config';
import {
  HttpErrorComponent,
  provideThemeLeptonX,
  withThemeLeptonXOptions,
} from '@volosoft/abp.ng.theme.lepton-x';
import { SideMenuLayoutModule } from '@volosoft/abp.ng.theme.lepton-x/layouts';
import { AccountLayoutModule } from '@volosoft/abp.ng.theme.lepton-x/account';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FaroInitializerService } from './shared/observability/faro-initializer-service';
import { AppVersionService } from './shared/services/app-version-service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { SeedlingSupplyReceptionPreset } from './seedling-supply-reception.style';
import {
  LPX_TRANSLATE_SERVICE_TOKEN,
  LPX_TRANSLATE_TOKEN,
} from '@volo/ngx-lepton-x.core';
import { lightTheme, LPX_THEMES } from '@volosoft/ngx-lepton-x';
import { LayoutTranslateDefaults } from '@volosoft/ngx-lepton-x/layouts';
import { LpxCustomTranslateService } from './shared/services/lpx-custom-translate.service';
import { APP_USER_MENU_PROVIDER } from './user-menu.provider';


const faroInitializer = (faroInitializer: FaroInitializerService) => () => faroInitializer;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ThemeSharedModule,
    CoreModule,
    AccountAdminConfigModule,
    IdentityConfigModule,
    AuditLoggingConfigModule,
    SideMenuLayoutModule.forRoot(),
    AccountLayoutModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    APP_ROUTE_PROVIDER,
    APP_USER_MENU_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: faroInitializer,
      deps: [FaroInitializerService],
      multi: true
    },
    AppVersionService,
    FaroInitializerService,
    provideAbpCore(
      withOptions({
        environment,
        registerLocaleFn: registerLocale(),
      }),
    ),
    provideAbpOAuth(),
    provideIdentityConfig(),
    provideSettingManagementConfig(),
    provideFeatureManagementConfig(),
    provideAccountAdminConfig(),
    provideAccountPublicConfig(),
    provideCommercialUiConfig(),
    provideAbpThemeShared(
      withHttpErrorConfig({
        errorScreen: {
          component: HttpErrorComponent,
          forWhichErrors: [401, 403, 404, 500],
          hideCloseIcon: true,
        },
      }),
      withValidationBluePrint({
        wrongPassword: 'Please choose 1q2w3E*',
      }),
    ),
    provideLogo(withEnvironmentOptions(environment)),
    provideLanguageManagementConfig(),
    provideSaasConfig(),
    provideAuditLoggingConfig(),
    provideOpeniddictproConfig(),
    provideTextTemplateManagementConfig(),
    provideThemeLeptonX(
      withThemeLeptonXOptions({
        defaultTheme: 'light',
        themeOptions: {
          localStorageKey: 'LPX_THEME',
          disableSystemOption: true,
        },
      }),
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: SeedlingSupplyReceptionPreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    {
      provide: LPX_THEMES,
      useValue: [lightTheme],
    },
    {
      provide: LPX_TRANSLATE_TOKEN,
      useValue: [LayoutTranslateDefaults],
      multi: true,
    },
    {
      provide: LPX_TRANSLATE_SERVICE_TOKEN,
      useClass: LpxCustomTranslateService,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
